import { useState } from 'react';

export const UseSetupMFAForm = () => {
    const [formData, setFormData] = useState({
        mfaData: null,
        mfaVerificationCode: '',
        mfaReverifyCode: '',
        mfaSetupComplete: false,
        isMFASetup: false,
        isMFAReverify: false
    });

    const handleVerificationCodeChange = (e) => {
        const mfaVerificationCode = e.target.value;
        setFormData(prev => ({
            ...prev,
            mfaVerificationCode
        }));
    };

    const handleReverifyCodeChange = (e) => {
        const mfaReverifyCode = e.target.value;
        setFormData(prev => ({
            ...prev,
            mfaReverifyCode
        }));
    };

    const setMFAData = (mfaData) => {
        setFormData(prev => ({
            ...prev,
            mfaData
        }));
    };

    const setMFASetupComplete = (mfaSetupComplete) => {
        setFormData(prev => ({
            ...prev,
            mfaSetupComplete
        }));
    };

    const setMFASetup = (isMFASetup) => {
        setFormData(prev => ({
            ...prev,
            isMFASetup
        }));
    };

    const setMFAReverify = (isMFAReverify) => {
        setFormData(prev => ({
            ...prev,
            isMFAReverify
        }));
    };

    const reset = () => {
        setFormData({
            mfaData: null,
            mfaVerificationCode: '',
            mfaReverifyCode: '',
            mfaSetupComplete: false,
            isMFASetup: false,
            isMFAReverify: false
        });
    };

    return {
        formData,
        handleVerificationCodeChange,
        handleReverifyCodeChange,
        setMFAData,
        setMFASetupComplete,
        setMFASetup,
        setMFAReverify,
        reset
    };
};
